import { Component, ReactNode } from 'react';

type State = {
  hasError: boolean;
  attempt: number;
};

type Props = {
  fallback?: ReactNode;
  children: ReactNode;
};

class ErrorBoundaryComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
      attempt: 0,
    };
  }

  static getDerivedStateFromError(_error: Error): Partial<State> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundaryComponent:', error, errorInfo);

    this.setState(prevState => ({
      attempt: prevState.attempt + 1,
    }));
  }

  render() {
    const { hasError, attempt } = this.state;

    if (hasError) {
      if (attempt < 2) {
        this.setState({ hasError: false });
        return null;
      }

      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default ErrorBoundaryComponent;
